import * as ko from "knockout";
import {IDiffParams, TDiffKey, TIds} from "./index";
import diffHtml from './diff.html?raw';

export let template: string = diffHtml;

interface IButton {
    count: KnockoutObservable<number | null>
    label: string
    title: string
    key: string
}

export class viewModel {

    private diffKey: KnockoutObservable<TDiffKey | null>
    private ids!: TIds

    private count: Record<TDiffKey, KnockoutObservable<number | null>> = {
        newfull: ko.observable(null),
        newonly: ko.observable(null),
        intersect: ko.observable(null),
        oldonly: ko.observable(null),
        oldfull: ko.observable(null),
    };

    buttons: IButton[] = [
        {
            title: "diff.tooltip.newfull",
            key: "newfull",
            label: "diff.btn.newfull",
            count: this.count.newfull,
        }, {
            title: "diff.tooltip.newonly",
            key: "newonly",
            label: "diff.btn.newonly",
            count: this.count.newonly,
        }, {
            title: "diff.tooltip.intersect",
            key: "intersect",
            label: "diff.btn.intersect",
            count: this.count.intersect,
        }, {
            title: "diff.tooltip.omitted",
            key: "oldonly",
            label: "diff.btn.omitted",
            count: this.count.oldonly,
        }, {
            title: "diff.tooltip.original",
            key: "oldfull",
            label: "diff.btn.original",
            count: this.count.oldfull,
        }
    ];

    constructor(params: IDiffParams) {
        this.ids = params.ids
        this.diffKey = params.diffKey

        this.count.newfull(this.ids.newfull?.length ?? 0)
        this.count.newonly(this.ids.newonly?.length ?? 0)
        this.count.intersect(this.ids.intersect?.length ?? 0)
        this.count.oldonly(this.ids.oldonly?.length ?? 0)
        this.count.oldfull(this.ids.oldfull?.length ?? 0)
    }

}
